import type { CustomerModuleProcess } from "@porsche-customer/formular1-cap-customer-module"
import { capCustomerModuleStart } from "@porsche-customer/formular1-cap-customer-module"
import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import type { CapFormView } from "@slfinrtl/ui-bff-routes"
import { useEffect, useState } from "react"
import type { OpenCapFunction } from "src/types/OpenCapFunction"

export const useCapCustomerModule = (view: CapFormView | undefined, process: CustomerModuleProcess) => {
	const [openCap, setOpenCap] = useState<OpenCapFunction | null>()
	const context = useDealerContext()
	useEffect(() => {
		if (!view) {
			return
		}
		capCustomerModuleStart({
			country: context.marketplaceKey,
			dealerContext: { ...context, dealershipId: context.partnerNumber },
			process,
		})
			.then((callback) => {
				const { importerPartnerNumber, orderTypeCode, ppnUserId, vin } = view
				if (!importerPartnerNumber || !orderTypeCode) {
					setOpenCap(null)
					return
				}

				setOpenCap(
					() => () =>
						callback({
							employee: ppnUserId,
							importer: importerPartnerNumber,
							orderType: orderTypeCode,
							process,
							vin,
						}),
				)
			})
			.catch(() => setOpenCap(null))
	}, [setOpenCap, view, context, process])

	return openCap
}
